/**
 * @class MatchingData
 *
 * Represents data from matching
 */
export default class MatchingData {
    /**
     * @param colorantList {Array}
     * @param bipp {Object}
     * @param priceData {Array}
     * @param colorDifferences {Array}
     * @param rgb {Number}
     * @param contrastRatio {Number}
     * @param lrv {Number}
     * @param metamerism {Number}
     * @param metamerismDin {Number}
     * @param asIsColorDifferences {Array}
     */
    constructor(
        colorantList,
        bipp,
        priceData,
        colorDifferences,
        rgb,
        contrastRatio,
        lrv,
        metamerism,
        metamerismDin,
        asIsColorDifferences = null
    ) {
        this._colorantList = colorantList;
        this._bipp = bipp;
        this._priceData = priceData;
        this._colorDifferences = colorDifferences;
        this._rgb = rgb;
        this._contrastRatio = contrastRatio;
        this._lrv = lrv;
        this._metamerism = metamerism;
        this._metamerismDin = metamerismDin;
        this._asIsColorDifferences = asIsColorDifferences;

        if (!Array.isArray(this._colorantList) || this._bipp === null) {
            throw new Error("Invalid MatchingData values");
        }

        this._key = this.buildKey();
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get colorantList() {
        return this._colorantList;
    }

    set colorantList(value) {
        this._colorantList = value;
    }

    get bipp() {
        return this._bipp;
    }

    set bipp(value) {
        this._bipp = value;
    }

    get priceData() {
        return this._priceData;
    }

    set priceData(value) {
        this._priceData = value;
    }

    get colorDifferences() {
        return this._colorDifferences;
    }

    set colorDifferences(value) {
        this._colorDifferences = value;
    }

    get rgb() {
        return this._rgb;
    }

    set rgb(value) {
        this._rgb = value;
    }

    get contrastRatio() {
        return this._contrastRatio;
    }

    set contrastRatio(value) {
        this._contrastRatio = value;
    }

    get lrv() {
        return this._lrv;
    }

    set lrv(value) {
        this._lrv = value;
    }

    get metamerism() {
        return this._metamerism;
    }

    set metamerism(value) {
        this._metamerism = value;
    }

    get metamerismDin() {
        return this._metamerismDin;
    }

    set metamerismDin(value) {
        this._metamerismDin = value;
    }

    get asIsColorDifferences() {
        return this._asIsColorDifferences;
    }

    set asIsColorDifferences(value) {
        this._asIsColorDifferences = value;
    }

    buildKey = () => {
        let key = "";

        for (let colorant of this._colorantList) {
            key += String(colorant.id);
        }

        return key + "-" + this._bipp.id + "-" + String(this._contrastRatio);
    };
}
